/**
 * Onboarding store — leaf module (Perf 3.1.b Step 5).
 */
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { getStorage } from './storage';

const useOnboardingStore = create(
  persist(
    (set, get) => ({
      isActive: false,
      requestedByUserId: null,
      personalStatus: {},
      currentStep: 1,
      totalSteps: 5,
      targets: {}, // { [step]: { ref: React.RefObject, rect: DOMRect } }

      actions: {
        startOnboarding: ({ userId = null } = {}) => set({ isActive: true, currentStep: 1, requestedByUserId: userId }),
        stopOnboarding: () => set({ isActive: false, currentStep: 1, requestedByUserId: null }),
        setPersonalStatus: (userId, status) => set(state => ({
          // Completion is final; a slower status request cannot bring the invitation back.
          personalStatus: { ...state.personalStatus, [userId]: state.personalStatus[userId]?.completedAt ? state.personalStatus[userId] : status },
        })),
        nextStep: () => {
          const { currentStep, totalSteps } = get();
          if (currentStep < totalSteps) {
            set({ currentStep: currentStep + 1 });
          } else {
            get().actions.stopOnboarding();
          }
        },
        prevStep: () => {
          const { currentStep } = get();
          if (currentStep > 1) {
            set({ currentStep: currentStep - 1 });
          }
        },
        setStep: (step) => set({ currentStep: step }),
        
        registerTarget: (step, ref) => {
          set(state => ({
            targets: {
              ...state.targets,
              [step]: { ref }
            }
          }));
        },
        
        unregisterTarget: (step) => {
          set(state => {
            const newTargets = { ...state.targets };
            delete newTargets[step];
            return { targets: newTargets };
          });
        },
        
        updateTargetRect: (step, rect) => {
          set(state => ({
            targets: {
              ...state.targets,
              [step]: {
                ...state.targets[step],
                rect
              }
            }
          }));
        }
      }
    }),
    {
      name: "onboarding-storage",
      storage: createJSONStorage(() => getStorage()),
      // Retire any in-progress setup from an older installation.
      merge: (persisted, current) => ({ ...current, ...persisted, isActive: false, requestedByUserId: null }),
      partialize: (state) => ({
        isActive: state.isActive,
        currentStep: state.currentStep,
      }),
    }
  )
);

export { useOnboardingStore };
export default useOnboardingStore;
